import axios from './providers/axios';
import {convertBooleanValuesToNumbers} from "@/utils/utils";

const programService = {
    getPrograms(page, filters = []) {
        if (filters && filters.length > 0) {
            const tempFilters = filters.map((filter) => {
                return `&${filter.key}=${filter.value}`;
            }).join('');

            return axios.get(`/v1/admin/program/store?limit=20&page=${page}${tempFilters}`);
        } else {
            return axios.get(`/v1/admin/program/store?limit=20&page=${page}`);
        }
    },

    getCompanyPrograms(page, company, filters = [], searchText = '', limit = 20) {
        let queryParams = `limit=${limit}&page=${page}&companyId=${company}&type=program`;

        if (searchText) {
            queryParams += `&searchText=${encodeURIComponent(searchText)}`;
        }

        if (filters && filters.length > 0) {
            const tempFilters = filters.map((filter) => {
                return `&${filter.key}=${filter.value}`;
            }).join('');
            queryParams += tempFilters;
        }

        return axios.get(`/v1/admin/company/getAssigned?${queryParams}`);
    },

    getAssignedJourneyPrograms(page, filters = []) {
        let queryParams = `isAssigned=1&journeyList=1&limit=20&page=${page}`;

        if (filters && filters.length > 0) {
            filters.forEach((filter) => {
                if (Array.isArray(filter.value)) {
                    filter.value.forEach((item, index) => {
                        Object.keys(item).forEach(key => {
                            queryParams += `&${filter.key}[${index}][${key}]=${item[key]}`;
                        });
                    });
                } else {
                    queryParams += `&${filter.key}=${filter.value}`;
                }
            });
        }

        return axios.get(`/v1/admin/program/store?${queryParams}`);
    },

    getProgramModules(id) {
        return axios.get(`/v1/admin/program/module/store/${id}?list=1`);
    },

    addProgram(data, lang = 'tr') {
        data = convertBooleanValuesToNumbers(data);

        return axios.post('/v2/admin/program/add', data, {
            headers: {
                'Content-Type': 'multipart/form-data',
                "Accept-Language": lang,
            }
        });
    },

    updateProgram(data, lang = 'tr') {
        data = convertBooleanValuesToNumbers(data);

        return axios.post('/v2/admin/program/update', data, {
            headers: {
                'Content-Type': 'multipart/form-data',
                "Accept-Language": lang,
            }
        });
    },

    getProgramDetail(id, lang = 'tr') {
        return axios.get(`/v2/admin/program/getFromId/${id}`, {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Accept-Language": lang,
            },
        });
    },

    assignProgram(data) {
        return axios.post('/v1/admin/program/assign', data);
    },

    deleteProgramAssign(data) {
        return axios.post('/v1/admin/program/assign/delete', data);
    },

    fetchProgramWeights(id) {
        return axios.get(`/v1/admin/program/weightNote/store?programId=${id}`);
    },

    saveWeights(data) {
        return axios.post('/v1/admin/program/weightNote/addOrUpdate', data);
    },

    getCopy(programId) {
        return axios.post('/v2/admin/program/copy', {
            programId: programId
        });
    },

    getModulesSubModules(programId) {
        return axios.get(`/v2/admin/program/getModulesSubModules/${programId}`);
    },

    getProgramList() {
        return axios.get('/v1/admin/program/store?list=1')
    },

    deleteProgram(id) {
        return axios.delete(`/v1/admin/program/delete/${id}`);
    },

    createWeblink(programId) {
        return axios.post('/v1/admin/program/generateShortCode', {
            programId: programId
        });
    },

    // Pagination eklendi
    getDetailLogs(lang, id) {
        return axios.get(`/v1/admin/program/getLogById/${id}`, {
            headers: {
                "Accept-Language": lang,
            }
        });
    },

    getUserPrograms(page, userId, filters = [], searchText = '', limit = 20) {
        let queryParams = `limit=${limit}&page=${page}&userId=${userId}&type=program`;

        if (searchText) {
            queryParams += `&searchText=${encodeURIComponent(searchText)}`;
        }

        if (filters && filters.length > 0) {
            const tempFilters = filters.map((filter) => {
                return `&${filter.key}=${filter.value}`;
            }).join('');
            queryParams += tempFilters;
        }

        return axios.get(`/v1/admin/user/getAssigned?${queryParams}`);
    },

    getAssignedPrograms(userId, type = 'program') {
        return axios.get('/v1/admin/user/getAssigned', {
            params: {
                userId,
                type
            }
        });
    }
}

export default programService;
